// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_user_files_s3_bucket": "alphafold2-prod",
  // "aws_user_files_s3_bucket": "past-prod",
  "aws_user_files_s3_bucket_region": "us-east-1",
  // Auth: {
  //   identityPoolId: "us-east-1:8bc72d77-a06e-4454-95a0-7e716e26bb84",
  //   region: "us-east-1",

  //   oauth: {
  //   },
  // },
  Auth: {
    //identityPoolId: "ap-northeast-1:dffce4c1-b44b-414c-88df-ee326bd460d1", // example: 'us-east-2:c85f3c18-05fd-4bb5-8fd1-e77e7627a99e'
    region: "us-east-1", // example: 'us-east-2'
    userPoolId: "us-east-1_ioaFofevA", // example: 'us-east-2_teEUQbkUh'
    userPoolWebClientId: "5clnak1on1g8i6l098vl2ll789", // http://localhost:3000
    // userPoolWebClientId: "1iq8fbenh2bftgki0d0a56b7s4", // http://localhost:3001
    identityPoolId: "us-east-1:0c07467d-bd5b-4dcd-9c79-ec1aee883b29",

    oauth: {
      domain: "tibbdc.auth.us-east-1.amazoncognito.com",
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: "https://alphafold2.biodesign.ac.cn/home",
      redirectSignOut: "https://alphafold2.biodesign.ac.cn",
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
  API: {
    endpoints: [
      {
        name: "AlphaFold2",
        endpoint: "https://qsf3dje2p1.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1",
      },
    ],
  }
};


export default awsmobile;
